module.exports = __webpack_public_path__ + "static/media/eye-close.968e0dde.svg";